import React from 'react';
import { usePermissions } from '../contexts/PermissionContext';

const PermissionGate = ({ 
  children, 
  permission = null, 
  role = null, 
  anyPermission = null,
  anyRole = null,
  fallback = null,
  requireAll = false 
}) => {
  const { 
    hasPermission, 
    hasRole, 
    hasAnyPermission, 
    hasAnyRole 
  } = usePermissions();

  let hasAccess = true;

  if (requireAll) {
    // User must have ALL specified permissions/roles
    if (permission && !hasPermission(permission)) hasAccess = false;
    if (role && !hasRole(role)) hasAccess = false;
    if (anyPermission && !hasAnyPermission(anyPermission)) hasAccess = false;
    if (anyRole && !hasAnyRole(anyRole)) hasAccess = false;
  } else {
    // User must have ANY of the specified permissions/roles
    hasAccess = false;
    
    if (permission && hasPermission(permission)) hasAccess = true;
    if (role && hasRole(role)) hasAccess = true;
    if (anyPermission && hasAnyPermission(anyPermission)) hasAccess = true;
    if (anyRole && hasAnyRole(anyRole)) hasAccess = true;
    
    // If no conditions are specified, allow access
    if (!permission && !role && !anyPermission && !anyRole) {
      hasAccess = true;
    }
  }

  if (hasAccess) {
    return children;
  }

  return fallback;
};

export default PermissionGate;
